import { render, staticRenderFns } from "./bg.vue?vue&type=template&id=286ec27c&scoped=true"
import script from "./bg.vue?vue&type=script&lang=js"
export * from "./bg.vue?vue&type=script&lang=js"
import style0 from "./bg.vue?vue&type=style&index=0&id=286ec27c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ec27c",
  null
  
)

export default component.exports